import React from 'react';
import MainLayout from '../../components/MainLayout';
import TabMenu from '../../components/TabMenu';
import CompanyManagement from './CompanyManagement';
import DataVerification from './DataVerification';
import './AdminPage.css';

function AdminPage() {
  const tabs = [
    {
      id: 'company',
      label: '회사 관리',
      icon: 'business',
      content: <CompanyManagement />
    },
    {
      id: 'data',
      label: '데이터 확인',
      icon: 'analytics',
      content: <DataVerification />
    }
  ];

  const handleTabChange = (tabId) => {
    // 탭 변경 시 필요한 처리
  };

  return (
    <MainLayout>
      <div className="admin-page-container">
        <div className="admin-page-header">
          <div className="admin-page-header-left">
            <div className="admin-page-title">관리자 페이지</div>
            <p className="admin-page-subtitle">회사 및 데이터 관리</p>
          </div>
        </div>

        <div className="admin-page-content">
          <TabMenu
            tabs={tabs}
            defaultTab="company"
            orientation="vertical"
            onTabChange={handleTabChange}
          />
        </div>
      </div>
    </MainLayout>
  );
}

export default AdminPage;
